import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export class AdditonalOverlay extends PIXI.Container implements StageLayer {


    constructor() {
        super();
        this.name = "addtionalOverlay";

    }

    onResize(): void {

    }

}